import { Box, Button, Card, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const ink = '#1a1a2e';
const muted = '#5a6478';
const band =
  'linear-gradient(135deg, rgba(1, 235, 178, 0.14) 0%, rgba(13, 78, 254, 0.1) 55%, rgba(13, 78, 254, 0.04) 100%)';

export const LaunchWrapper = styled(Box)({
  maxWidth: 1200,
  margin: '0 auto',
  padding: '2rem 1rem 3.5rem',
  minHeight: '100%',
  background: 'linear-gradient(180deg, #f0f4f8 0%, #f7fafc 35%, #ffffff 100%)',
  backgroundAttachment: 'fixed',
});

export const HeroSection = styled(Box)({
  marginBottom: '2rem',
  padding: '1.85rem 1.35rem',
  borderRadius: 16,
  background: band,
  border: '1px solid rgba(13, 78, 254, 0.1)',
  boxShadow: '0 8px 28px rgba(13, 78, 254, 0.08)',
});

export const HeroTopRow = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'auto minmax(240px, 1fr)',
  alignItems: 'center',
  columnGap: 'clamp(1rem, 3vw, 2.25rem)',
  rowGap: '0.85rem',
  '@media (max-width: 600px)': {
    gridTemplateColumns: '1fr',
    textAlign: 'center',
    alignItems: 'center',
  },
});

export const HeroLogo = styled('img')({
  display: 'block',
  width: 'auto',
  height: 'clamp(92px, 16vw, 140px)',
  maxWidth: 'min(360px, 100%)',
  objectFit: 'contain',
  flexShrink: 0,
  filter: 'drop-shadow(0 4px 12px rgba(13, 78, 254, 0.15))',
});

export const HeroHeadlineBlock = styled(Box)({
  minWidth: 0,
});

export const HeroBadge = styled(Box)({
  display: 'inline-block',
  marginBottom: '0.85rem',
  padding: '6px 12px',
  borderRadius: 999,
  fontSize: '0.75rem',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: '#0d4efe',
  backgroundColor: 'rgba(13, 78, 254, 0.1)',
});

export const LaunchDateSection = styled(Box)({
  marginBottom: '2rem',
  padding: '2rem 1.5rem',
  borderRadius: 16,
  textAlign: 'center',
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.18) 0%, rgba(13, 78, 254, 0.12) 50%, rgba(13, 78, 254, 0.06) 100%)',
  border: '1px solid rgba(13, 78, 254, 0.14)',
  boxShadow: '0 10px 32px rgba(13, 78, 254, 0.12)',
});

export const LaunchDateKicker = styled(Typography)({
  fontSize: '0.72rem',
  fontWeight: 800,
  letterSpacing: '0.14em',
  textTransform: 'uppercase',
  color: '#0d4efe',
  marginBottom: '0.5rem',
});

export const LaunchDateHeading = styled('h2')({
  margin: '0 0 1.25rem',
  color: ink,
  fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
  fontWeight: 700,
  lineHeight: 1.3,
});

export const LaunchDateDisplay = styled(Box)({
  display: 'inline-flex',
  alignItems: 'stretch',
  gap: 'clamp(0.75rem, 2.5vw, 1.5rem)',
  marginBottom: '1.25rem',
  padding: '1.25rem clamp(1rem, 4vw, 2rem)',
  borderRadius: 14,
  background: '#ffffff',
  border: '1px solid rgba(13, 78, 254, 0.12)',
  boxShadow: '0 8px 24px rgba(13, 78, 254, 0.1)',
  '@media (max-width: 480px)': {
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.35rem',
  },
});

export const LaunchDatePart = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 'clamp(72px, 18vw, 110px)',
  '@media (max-width: 480px)': {
    minWidth: 'auto',
  },
});

export const LaunchDatePartLabel = styled('span')({
  fontSize: '0.7rem',
  fontWeight: 800,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: muted,
  marginBottom: '0.2rem',
});

export const LaunchDatePartValue = styled('span')({
  fontSize: 'clamp(1.75rem, 5vw, 2.75rem)',
  fontWeight: 800,
  lineHeight: 1,
  letterSpacing: '-0.02em',
  color: '#0d4efe',
  backgroundImage: 'linear-gradient(90deg, #0d4efe 0%, #01ebb2 100%)',
  backgroundRepeat: 'no-repeat',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  fontFamily: "'Plus Jakarta Sans', 'Exo 2', sans-serif",
});

export const LaunchDateDivider = styled(Box)({
  width: 1,
  alignSelf: 'stretch',
  backgroundColor: 'rgba(13, 78, 254, 0.15)',
  '@media (max-width: 480px)': {
    width: '60%',
    height: 1,
    alignSelf: 'center',
  },
});

export const LaunchDateDescription = styled('p')({
  margin: 0,
  maxWidth: 640,
  marginLeft: 'auto',
  marginRight: 'auto',
  color: muted,
  fontSize: '0.98rem',
  lineHeight: 1.6,
});

export const HeroBrandTitle = styled('h1')({
  margin: '0 0 0.5rem',
  display: 'inline-block',
  fontSize: 'clamp(2rem, 5vw, 2.85rem)',
  fontWeight: 800,
  lineHeight: 1.12,
  letterSpacing: '-0.02em',
  color: '#0d4efe',
  backgroundImage: 'linear-gradient(90deg, #0d4efe 0%, #01ebb2 100%)',
  backgroundRepeat: 'no-repeat',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  fontFamily: "'Plus Jakarta Sans', 'Exo 2', sans-serif",
});

export const HeroTagline = styled('p')({
  margin: 0,
  color: ink,
  fontSize: 'clamp(1.15rem, 2.8vw, 1.55rem)',
  lineHeight: 1.35,
  fontWeight: 700,
  maxWidth: '44rem',
  '@media (max-width: 600px)': {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

export const HeroSubtitle = styled('p')({
  margin: '0.65rem 0 0',
  color: muted,
  maxWidth: 780,
  fontSize: '1rem',
  lineHeight: 1.55,
  '@media (max-width: 600px)': {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

export const ContactSignupSection = styled(Box)({
  marginTop: '1.75rem',
  padding: '1.35rem 1.25rem 1.5rem',
  borderRadius: 12,
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.1) 0%, rgba(13, 78, 254, 0.07) 55%, rgba(13, 78, 254, 0.03) 100%)',
  border: '1px solid rgba(13, 78, 254, 0.12)',
});

export const ContactSignupDividerRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.85rem',
  marginBottom: '1rem',
});

export const ContactSignupDividerLine = styled(Box)({
  flex: 1,
  height: 1,
  backgroundColor: 'rgba(13, 78, 254, 0.18)',
});

export const ContactSignupDividerLabel = styled(Typography)({
  fontSize: '0.8rem',
  fontWeight: 800,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: '#5a6478',
  flexShrink: 0,
});

export const ContactSignupSubtitle = styled(Typography)({
  marginBottom: '1rem',
  textAlign: 'center',
  fontSize: '0.95rem',
  lineHeight: 1.55,
  color: muted,
});

export const ContactSignupButton = styled(Button)({
  display: 'flex',
  width: 'fit-content',
  minWidth: 240,
  margin: '0 auto',
  justifyContent: 'center',
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '1rem',
  borderRadius: 10,
  padding: '12px 32px',
  color: '#fff',
  background: 'linear-gradient(90deg, #01ebb2 0%, #0d4efe 100%)',
  boxShadow: '0 4px 14px rgba(13, 78, 254, 0.35)',
  '&:hover': {
    background: 'linear-gradient(90deg, #02d9a8 0%, #0a45e0 100%)',
    boxShadow: '0 6px 18px rgba(13, 78, 254, 0.42)',
  },
});

export const PreviewSection = styled(Box)({
  marginBottom: '2rem',
  padding: '1.75rem 1.25rem',
  borderRadius: 16,
  background: band,
  border: '1px solid rgba(13, 78, 254, 0.1)',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.04)',
});

export const SectionKicker = styled(Typography)({
  fontSize: '0.72rem',
  fontWeight: 800,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: '#0d4efe',
  marginBottom: '0.35rem',
});

export const SectionTitle = styled('h2')({
  margin: '0 0 0.5rem',
  color: ink,
  fontSize: 'clamp(1.35rem, 2.8vw, 1.65rem)',
  fontWeight: 700,
});

export const SectionDescription = styled('p')({
  margin: '0.65rem 0 0',
  color: muted,
  fontSize: '0.98rem',
  lineHeight: 1.6,
  maxWidth: 820,
});

export const SectionLead = styled('p')({
  margin: '0 0 1.5rem',
  color: muted,
  fontSize: '0.98rem',
  lineHeight: 1.55,
  maxWidth: 720,
});

export const LaunchPanel = styled(Card)({
  height: '100%',
  borderRadius: 16,
  overflow: 'hidden',
  border: '1px solid rgba(13, 78, 254, 0.12)',
  boxShadow: '0 10px 32px rgba(13, 78, 254, 0.1)',
  display: 'flex',
  flexDirection: 'column',
});

export const LaunchPanelHeader = styled(Box)({
  padding: '1rem 1.25rem',
  background: band,
  borderBottom: '1px solid rgba(13, 78, 254, 0.1)',
});

export const LaunchPanelTitle = styled(Typography)({
  fontWeight: 700,
  color: ink,
  fontSize: '1.15rem',
});

export const LaunchPanelSubtitle = styled('p')({
  margin: '0.5rem 0 0',
  fontSize: '0.9rem',
  lineHeight: 1.55,
  color: muted,
  maxWidth: '42rem',
  fontWeight: 500,
});

export const LaunchPanelBody = styled(Box)({
  flex: 1,
  padding: '1.35rem 1.25rem 1.5rem',
  background: '#ffffff',
});

export const ProviderBenefitsWell = styled(Box)({
  padding: '1.35rem 1.2rem',
  borderRadius: 14,
  background: 'linear-gradient(180deg, #f7fafc 0%, #f0f4f8 100%)',
  border: '1px solid rgba(13, 78, 254, 0.1)',
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.85)',
});

export const ProviderBenefitsGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '0.95rem',
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr',
  },
});

export const ProviderBenefitCard = styled(Box)({
  display: 'flex',
  gap: '0.9rem',
  alignItems: 'flex-start',
  padding: '1rem 1rem',
  borderRadius: 12,
  background: '#ffffff',
  border: '1px solid rgba(0, 0, 0, 0.06)',
  boxShadow: '0 2px 10px rgba(13, 78, 254, 0.06)',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    borderColor: 'rgba(13, 78, 254, 0.22)',
    boxShadow: '0 6px 18px rgba(13, 78, 254, 0.1)',
  },
});

export const ProviderBenefitMark = styled(Box)({
  flexShrink: 0,
  width: 38,
  height: 38,
  borderRadius: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background:
    'linear-gradient(145deg, rgba(1, 235, 178, 0.22) 0%, rgba(13, 78, 254, 0.16) 100%)',
  border: '1px solid rgba(13, 78, 254, 0.12)',
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.5)',
  fontSize: '1.05rem',
  fontWeight: 800,
  color: '#0d4efe',
  fontFamily: "'Plus Jakarta Sans', sans-serif",
});

export const ProviderBenefitText = styled(Box)({
  minWidth: 0,
});

export const ProviderBenefitTitle = styled('h3')({
  margin: '0 0 0.35rem',
  fontSize: '0.98rem',
  fontWeight: 700,
  color: ink,
  lineHeight: 1.35,
  fontFamily: "'Plus Jakarta Sans', sans-serif",
});

export const ProviderBenefitDescription = styled('p')({
  margin: 0,
  fontSize: '0.88rem',
  lineHeight: 1.58,
  color: muted,
});

export const AboutInnerWell = styled(Box)({
  padding: '1.35rem 1.2rem',
  borderRadius: 14,
  background: 'linear-gradient(180deg, #f7fafc 0%, #f0f4f8 100%)',
  border: '1px solid rgba(13, 78, 254, 0.1)',
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.85)',
});

export const AboutPointsStack = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.64rem',
});

export const AboutPointCard = styled(Box)({
  display: 'flex',
  gap: '0.9rem',
  alignItems: 'flex-start',
  padding: '0.95rem 1rem',
  borderRadius: 12,
  background: '#ffffff',
  border: '1px solid rgba(0, 0, 0, 0.06)',
  boxShadow: '0 2px 10px rgba(13, 78, 254, 0.06)',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    borderColor: 'rgba(13, 78, 254, 0.22)',
    boxShadow: '0 6px 18px rgba(13, 78, 254, 0.1)',
  },
});

export const AboutPointMark = styled(Box)({
  flexShrink: 0,
  width: 36,
  height: 36,
  borderRadius: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background:
    'linear-gradient(145deg, rgba(1, 235, 178, 0.22) 0%, rgba(13, 78, 254, 0.16) 100%)',
  border: '1px solid rgba(13, 78, 254, 0.12)',
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.5)',
  fontSize: '1.05rem',
  fontWeight: 800,
  color: '#0d4efe',
  fontFamily: "'Plus Jakarta Sans', sans-serif",
});

export const AboutPointText = styled(Box)({
  minWidth: 0,
});

export const AboutPointTitle = styled('h3')({
  margin: '0 0 0.35rem',
  fontSize: '0.95rem',
  fontWeight: 700,
  color: ink,
  lineHeight: 1.35,
  fontFamily: "'Plus Jakarta Sans', sans-serif",
});

export const AboutPointDescription = styled('p')({
  margin: 0,
  fontSize: '0.88rem',
  lineHeight: 1.58,
  color: muted,
});

export const AboutClosingLine = styled('p')({
  margin: '1.15rem 0 0',
  fontSize: '0.86rem',
  lineHeight: 1.55,
  color: muted,
  fontStyle: 'italic',
  padding: '0.75rem 1rem',
  borderRadius: '0 10px 10px 0',
  background: 'linear-gradient(90deg, rgba(13, 78, 254, 0.09) 0%, rgba(1, 235, 178, 0.06) 100%)',
  borderLeft: '3px solid #0d4efe',
});

export const RolloutBanner = styled(Box)({
  marginTop: '1rem',
  padding: '1.05rem 1.2rem',
  borderRadius: 14,
  background:
    'linear-gradient(90deg, rgba(13, 78, 254, 0.14) 0%, rgba(1, 235, 178, 0.1) 100%)',
  border: '1px solid rgba(13, 78, 254, 0.22)',
  boxShadow: '0 10px 26px rgba(13, 78, 254, 0.14)',
  color: '#24314f',
  fontSize: '0.95rem',
  lineHeight: 1.55,
  fontStyle: 'italic',
  borderLeft: '6px solid #0d4efe',
  position: 'relative',
  '&::before': {
    content: '"!"',
    position: 'absolute',
    left: 14,
    top: 14,
    width: 34,
    height: 34,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(145deg, rgba(1, 235, 178, 0.22) 0%, rgba(13, 78, 254, 0.16) 100%)',
    border: '1px solid rgba(13, 78, 254, 0.14)',
    boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.55)',
    fontStyle: 'normal',
    fontSize: '1.1rem',
    fontWeight: 900,
  },
  paddingLeft: '3.35rem',
});

export const ScreenshotFigure = styled('figure')({
  margin: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 14,
  overflow: 'hidden',
  border: '1px solid rgba(13, 78, 254, 0.14)',
  background: '#fff',
  boxShadow: '0 6px 20px rgba(13, 78, 254, 0.12)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 12px 28px rgba(13, 78, 254, 0.18)',
  },
});

export const ScreenshotButton = styled('button')({
  all: 'unset',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  '&:focus-visible': {
    outline: '3px solid rgba(13, 78, 254, 0.35)',
    outlineOffset: 3,
    borderRadius: 14,
  },
});

export const ScreenshotImage = styled('img')({
  display: 'block',
  width: '100%',
  height: 'auto',
  minHeight: 160,
  maxHeight: 220,
  objectFit: 'cover',
  objectPosition: 'top center',
  borderBottom: '1px solid rgba(13, 78, 254, 0.08)',
});

export const ScreenshotCaption = styled(Typography)({
  padding: '12px 14px 14px',
  fontSize: '0.875rem',
  lineHeight: 1.45,
  color: muted,
  background: '#f7fafc',
  flex: 1,
});

export const EmptyScreenshotState = styled(Box)({
  padding: '1.25rem',
  borderRadius: 12,
  background: '#f7fafc',
  color: muted,
  border: '1px dashed rgba(13, 78, 254, 0.3)',
  fontSize: '0.9rem',
});

export const LightboxHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  padding: '14px 16px',
  background:
    'linear-gradient(135deg, rgba(1, 235, 178, 0.14) 0%, rgba(13, 78, 254, 0.1) 55%, rgba(13, 78, 254, 0.04) 100%)',
  borderBottom: '1px solid rgba(13, 78, 254, 0.12)',
});

export const LightboxImage = styled('img')({
  width: '100%',
  height: 'auto',
  maxHeight: '78vh',
  objectFit: 'contain',
  borderRadius: 12,
  border: '1px solid rgba(0, 0, 0, 0.06)',
  background: '#0b1020',
});
